// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2DATI","insightsList":"newBusinessInsightsMenu_insightsList__3_R2G","active":"newBusinessInsightsMenu_active__s2X5R"};